// Definition of file extensions
export const file_ext_def = {};
file_ext_def['.pl'] = {
  desc:'code', button_text:'.pl', action:'load', kind:'prolog',
  load_menu:true, debug_menu:true, more_menu:true
};
file_ext_def['.md'] = {
  desc:'document', button_text:'.md', action:'doc', kind:'markdown',
  load_menu:false, debug_menu:false, more_menu:false
};
file_ext_def['.lpdoc'] = {
  desc:'document', button_text:'.md', action:'doc', kind:'markdown',
  hide:true, // Do not include in "New" menu (would be repeated)
  load_menu:false, debug_menu:false, more_menu:false
};

/* The file extension indicates a documentation file (.md, .lpdoc) */
export function file_ext_is_doc(ext) {
  return file_ext_def[ext].action == 'doc';
}

